import React from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";

interface Props {
    backDrop?: boolean;
    open?: boolean;
}

const Loader = ({ backDrop, open }: Props) => {
    return backDrop ? (
        <Backdrop
            sx={{ backgroundColor: "rgba(180,180,180,0.5)", zIndex: theme => theme.zIndex.drawer + 1 }}
            // @ts-ignore
            open={open}
        >
            <CircularProgress />
        </Backdrop>
    ) : (
        <Box sx={{ display: "flex", height: "100%", width: "100%", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
        </Box>
    );
};

export default Loader;
